import { createBrowserHistory } from 'history';


/*=============================================
=            History for application          =
=============================================*/

export default createBrowserHistory();